import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { FaRegCopy } from 'react-icons/fa'
import {
  BtnIcon,
  CustomCheckbox,
  CustomDataTableHeader,
  CustomPanel,
  PageHeader,
} from '../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { tableCellCentered } from '../../../../assets/js/styles'
import * as colors from '../../../../assets/js/colors'
import { ROTAS_CHECKLIST } from '../../../../constants/checklist-operacional'
import { formatarDataExibicao, formatarDataHoraExibicao } from '../shared/checklist.util'
import useCadastroChecklist, { LOAD_MESSAGE } from './CadastroChecklistHook'

function CadastroChecklist({ selectedTp, dispatch, history }) {
  const { state, localDispatch } = useCadastroChecklist()

  useEffect(() => {
    localDispatch.onInit(selectedTp)
  }, [selectedTp])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break
      case LOAD_MESSAGE.INITIAL_GET:
        dispatch(showLoadingBox('Carregando checklists', 'Aguarde...'))
        localDispatch.getChecklists(state.selectedTp)
        break
      default:
        break
    }
  }, [state.loadingMessage, state.selectedTp])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  const onDuplicar = (event, checklist) => {
    event.stopPropagation()
    history.push(ROTAS_CHECKLIST.ESTRUTURA, { duplicarDe: checklist.id })
  }

  const header = (
    <CustomDataTableHeader
      onChange={value => localDispatch.onGlobalFilterChange(value)}
      value={state.globalFilter}
    />
  )

  return (
    <div>
      <PageHeader>10.1 - Cadastro de Checklist</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel
          onNovo={() => history.push(ROTAS_CHECKLIST.ESTRUTURA)}
          showBtnNovo={!!selectedTp}
          onVoltar={() => history.push(ROTAS_CHECKLIST.MENU)}
        >
          <DataTable
            header={header}
            value={state.checklists}
            paginator
            rows={15}
            selectionMode="single"
            onRowClick={e => history.push(ROTAS_CHECKLIST.ESTRUTURA, { checklistId: e.data.id })}
            globalFilter={state.globalFilter}
            emptyMessage="Nenhum checklist encontrado"
            dataKey="id"
          >
            <Column field="checklist_code" header="Código" style={{ width: 200 }} />
            <Column field="title" header="Título" />
            <Column
              field="reviewed_at"
              header="Data de Revisão"
              body={row => formatarDataExibicao(row.reviewed_at)}
              style={tableCellCentered(140)}
            />
            <Column
              field="created_at"
              header="Criado em"
              body={row => formatarDataHoraExibicao(row.created_at)}
              style={tableCellCentered(150)}
            />
            <Column
              header="Ativo"
              body={row => <CustomCheckbox disabled checked={!!row.actived} onChange={() => {}} />}
              style={tableCellCentered(80)}
            />
            <Column
              header="Duplicar"
              body={row => (
                <BtnIcon onClick={event => onDuplicar(event, row)}>
                  <FaRegCopy color={colors.azul} />
                </BtnIcon>
              )}
              style={tableCellCentered(90)}
            />
          </DataTable>
        </CustomPanel>
      </div>
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(CadastroChecklist))
